/**
 * #1241 — the text of a decrypted inbound envelope, never the raw envelope JSON.
 *
 * Every inbound parse site used to do `parsed.text ?? plaintext`. `??` (since
 * #1219) stops `text: ""` from falling through, but when the `text` KEY is
 * absent — or null, or not a string — `parsed.text` is nullish and the fallback
 * is the WHOLE envelope JSON string, `attachment.fileKey` / `fileNonce`
 * included. That string then becomes the room caption (the @ gate and the model
 * prompt), the history entry replayed for the next 20 turns, and the
 * `room_message` emit.
 *
 * Measured 2026-09-13 (issue #1241): no live sender produces a `type:"message"`
 * envelope without a `text` string, so this is hardening — but the receiver
 * must not depend on every present and future sender being well-formed.
 *
 * Rule: if `parsed` looks like one of our envelopes (an object carrying `type`
 * or `attachment`), its text is `text` when that is a string and `""`
 * otherwise. The raw-string fallback survives ONLY for plaintext that is not an
 * envelope at all (a bare JSON scalar, or an object with neither key — the
 * shape older status/heartbeat payloads use, whose behaviour is unchanged here).
 */
export function envelopeText(parsed: unknown, raw: string): string {
  if (parsed !== null && typeof parsed === "object") {
    const obj = parsed as Record<string, unknown>;
    if (typeof obj.text === "string") return obj.text;
    if ("type" in obj || "attachment" in obj) return "";
  }
  return raw;
}
